// extracted by mini-css-extract-plugin
export var loadingSpinner = "_11-0";
export var spinnerContainer = "_11-1";